var map = {
  "./lean__debugging__quality_of_logs.mock.json": [
    "940561",
    "31050"
  ],
  "./lean__estimation_accuracy__estimation_accuracy.mock.json": [
    "385326",
    "40131"
  ],
  "./coverage__completeness_of_requirements__reliability_and_availability.mock.json": [
    "195325",
    "44174"
  ],
  "./lean__test_run__test_stability.mock.json": [
    "832462",
    "31715"
  ],
  "./reliability__reliability_and_availability__availability_measured_in_nines_e_g_99_9_uptime.mock.json": [
    "135342",
    "91555"
  ],
  "./coverage__user_xp__web_ui_services.mock.json": [
    "408848",
    "26633"
  ],
  "./alignment__process__test_definition.mock.json": [
    "667526",
    "53131"
  ],
  "./coverage__requirements__business.mock.json": [
    "787172",
    "47621"
  ],
  "./alignment__requirements__nfr.mock.json": [
    "170563",
    "62240"
  ],
  "./coverage__completeness_of_requirements__usability_and_accessibility.mock.json": [
    "531454",
    "81715"
  ],
  "./coverage__code__back_end_services.mock.json": [
    "563549",
    "58094"
  ],
  "./alignment__requirements__business.mock.json": [
    "901009",
    "8266"
  ],
  "./alignment__process__quality_gates.mock.json": [
    "923384",
    "34305"
  ],
  "./alignment__process__test_implementation.mock.json": [
    "151007",
    "11924"
  ],
  "./coverage__user_xp__mobile_apps.mock.json": [
    "224991",
    "78420"
  ],
  "./lean__test_run__test_run_duration.mock.json": [
    "212691",
    "28560"
  ],
  "./alignment__process__risk_management_failures.mock.json": [
    "567683",
    "76416"
  ],
  "./coverage__code__bff_services.mock.json": [
    "366060",
    "85501"
  ],
  "./reliability__bugs_criticality__bugs_criticality.mock.json": [
    "769808",
    "81865"
  ],
  "./lean__debugging__debug_efficiency.mock.json": [
    "987555",
    "35616"
  ],
  "./coverage__completeness_of_requirements__maintainability_and_operability.mock.json": [
    "293585",
    "25514"
  ],
  "./coverage__completeness_of_requirements__security_and_privacy.mock.json": [
    "783516",
    "25517"
  ],
  "./alignment__process__roles.mock.json": [
    "644957",
    "98574"
  ],
  "./coverage__code__web_ui_services.mock.json": [
    "885365",
    "39286"
  ],
  "./coverage__user_xp__devices_apps.mock.json": [
    "115418",
    "50887"
  ],
  "./alignment__framework__environment.mock.json": [
    "309284",
    "20101"
  ],
  "./coverage__completeness_of_requirements__business.mock.json": [
    "267727",
    "83620"
  ],
  "./alignment__requirements__swagger.mock.json": [
    "957429",
    "2198"
  ],
  "./coverage__code__devices_apps.mock.json": [
    "185965",
    "33662"
  ],
  "./lean__process__a_i_usage.mock.json": [
    "778356",
    "84501"
  ],
  "./coverage__requirements__nfr.mock.json": [
    "318032",
    "71497"
  ],
  "./alignment__transparency__test_runs_quality_dashboard.mock.json": [
    "550749",
    "25550"
  ],
  "./alignment__framework__test_run_duration.mock.json": [
    "300274",
    "84719"
  ],
  "./coverage__code__mobile_apps.mock.json": [
    "970650",
    "98407"
  ],
  "./reliability__bugs_origin__bugs_origin_ratio.mock.json": [
    "830220",
    "48125"
  ],
  "./reliability__reliability_and_availability__uptime_measured_in_nines_e_g_99_9_uptime.mock.json": [
    "661463",
    "50364"
  ],
  "./coverage__completeness_of_requirements__performance_and_scalability.mock.json": [
    "841923",
    "97632"
  ],
  "./coverage__requirements__swagger.mock.json": [
    "255010",
    "87583"
  ],
  "./alignment__transparency__test_results_dashboard.mock.json": [
    "884395",
    "4696"
  ],
  "./alignment__framework__level_of_automation.mock.json": [
    "247015",
    "30124"
  ],
  "./lean__debugging__debug_tooling.mock.json": [
    "680978",
    "51375"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 282942;
module.exports = __rspack_async_context;
